import { Component } from '@angular/core';
import { Operator } from '../../../services/http/operators/operators.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OperatorsService } from '../../../services/http/operators/operators.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert/alert.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { MunicipalityManagement } from '../../../services/http/municipalities/municipalities.interface';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';

@Component({
  selector: 'app-operators-detail-page',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './operators-detail-page.component.html',
  styleUrl: './operators-detail-page.component.scss'
})
export class OperatorsDetailPageComponent {
  operatorId: string = '';
  operator: Operator | undefined;
  municipalities: MunicipalityManagement[] = [];

  constructor(
    private readonly operatorsService: OperatorsService,
    private readonly municipalitiesService: MunicipalitiesService,
    private readonly activeRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly loaderService: LoaderService,
    private readonly alertService: AlertService
  ) {
    this.operatorId = this.activeRoute.snapshot.paramMap.get('id') || '';
    this.municipalitiesService.getMunicipalitiesManagement().subscribe((data) => {
      this.municipalities = data.municipalities;
    });
    if (this.operatorId == 'new') {
      this.operator = {
        identifier: '',
        name: '',
        exceptions_profile: '',
        sanctioning_profile: '',
        municipalities: [],
        email: '',
      }
    } else {
      this.loaderService.show();
      this.operatorsService.getAllOperators().subscribe((operators) => {
        this.operator = operators.find((operator: Operator) => operator.identifier === this.operatorId);
        this.loaderService.hide();
        if (!this.operator) {
          this.alertService.setAlert({
            message: $localize`:@@Operators.Detail.NotFound:Operador no encontrado`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          this.router.navigate(['/operators']);
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/operators']);
  }

  save() {
    if (this.operator) {
      this.loaderService.show();
      if (this.operator.identifier === '') {
        this.operatorsService.addOperator(this.operator).subscribe({
          next: () => {
            this.loaderService.hide();
            this.alertService.setAlert({
              message: $localize`:@@Operators.Detail.Created:Operador creado correctamente`,
              type: AlertType.Success,
              dismissible: true,
              dismissOnTimeout: 5000
            });
            this.router.navigate(['/operators']);
          }
        });
      } else {
        this.operatorsService.updateOperator(this.operator).subscribe({
          next: () => {
            this.loaderService.hide();
            this.alertService.setAlert({
              message: $localize`:@@Operators.Detail.Updated:Operador actualizado correctamente`,
              type: AlertType.Success,
              dismissible: true,
              dismissOnTimeout: 5000
            });
            this.router.navigate(['/operators']);
          }
        });
      }
    }
  }
}
